
import { Breadcrumb ,Spin } from "antd";
import { RightOutlined, HomeOutlined } from "@ant-design/icons";
import Layout from "Layout"; // nếu bạn có layout, nếu không remove
import "./TransactionHistory.scss";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { mixGetV1 } from "services/mixin";

export default function OrderDetailCard() {
  const { id } = useParams<{ id: string }>();
  const [order, setOrder] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const statusMap = {
    1: { label: "Mới", className: "bg-[#096dd9] text-white" },    
    2: { label: "Đang xử lý", className: "bg-[#f59e0b] text-white" },
    3: { label: "Đã thanh toán", className: "bg-[#10b981] text-white" },
    4: { label: "Thất bại", className: "bg-red-500 text-white" }, 
  };
  // const order = {
  //   code: "DH2511201E",
  //   date: "20/11/2025",
  //   customer: {
  //     name: "Không xác định",
  //     phone: "0701201245",
  //     email: "chuantest@gmail.com",
  //   },
  //   status: "unpaid",
  //   items: [
  //     {
  //       name: "BASIC 1 YEAR",
  //       price: 45_000,
  //       qty: 1,
  //       total: 45_000,
  //     },
  //   ],
  //   subtotal: 45_000,
  //   total: 45_000,
  //   seller: "Hệ thống",
  // };
  useEffect(() => {
    if (!id) return;
    const fetchOrder = async () => {
      setLoading(true);
      try {
        const res = await mixGetV1(`/api/v1/be/order/${id}`);
        if (res.status) {
          setOrder(res.data);
        }
      } catch (err) {
        console.error("Lỗi khi fetch order:", err);
        
      }
      setLoading(false);
    };
    fetchOrder();
  }, [id]);

  if (loading || !order) return <Spin style={{ margin: "100px auto", display: "block" }} />;

  return (
    <Layout>
      <div style={{ marginBottom: 16, display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
        <h2 style={{ fontWeight: 600, fontSize: 24, marginBottom: 0, color: "#6e6b7b", borderRight: "1px solid #d6dce1", paddingRight: 12 }}>
          Lịch sử giao dịch
        </h2>
        <Breadcrumb
          separator={<RightOutlined style={{ fontSize: 12, color: "#6e6b7b" }} />}
          items={[
            {
              title: (
                <a href="#">
                  <HomeOutlined style={{ color: "#096dd9", fontSize: 16 }} />
                </a>
              ),
            },
            {
              title: (
                <a href="/lich-su">
                  Danh sách
                </a>
              ),
            },
            { title: "Chi tiết" },
          ]}
        />
      </div>

      <div className="bg-white rounded-xl border p-6 shadow-sm">
        {/* TOP INFO */}
        <div className="flex flex-col md:flex-row justify-between gap-4 mb-6">

          {/* LEFT SIDE */}
          <div className="text-gray-700 space-y-1">
            <p>
              <span className="font-semibold">Khách hàng:</span> {order.customer.first_name} {order.customer.last_name}
            </p>
            <p>
              <span className="font-semibold">Số điện thoại:</span> {order.customer.phone}
            </p>
            <p>
              <span className="font-semibold">Email:</span>{" "}
              <span className="text-blue-600">{order.customer.email}</span>
            </p>
          </div>

          {/* RIGHT SIDE */}
          <div className="text-gray-700 space-y-1 text-right">
            <p>
              <span className="font-semibold">Mã ĐH:</span>{" "}
              <span className="text-blue-600 font-semibold">#{order.code}</span>
            </p>
            <p>
              <span className="font-semibold">Ngày mua:</span> {new Date(order.created_at).toLocaleDateString("vi-VN")}
            </p>
            <p className="flex justify-end items-center gap-2">
              <span className="font-semibold">Thanh toán:</span>
              <span className={`${statusMap[order?.status]?.className || "badge-unknown"} px-3 py-1 rounded text-xs font-semibold`}>
                {statusMap[order?.status]?.label || "Không xác định"}
              </span>
            </p>
          </div>
        </div>

        {/* PRODUCT TABLE */}
        <div className="border rounded-lg overflow-hidden">

          {/* HEADER */}
          <div className="hidden md:grid grid-cols-4 bg-[#f3f2f7] text-gray-600 font-semibold text-sm px-4 py-3">
            <div>SẢN PHẨM</div>
            <div>GIÁ</div>
            <div>SỐ LƯỢNG</div>
            <div>TỔNG TIỀN</div>
          </div>

          {/* ITEMS */}
          {order.package && (
            <div key={order.package.id}>

              {/* DESKTOP VIEW */}
              <div className="hidden md:grid grid-cols-4 px-4 py-3 border-t text-gray-700">
                <div>{order.package.name}</div>
                <div>{(order.total ?? 0).toLocaleString()} $</div>
                <div>1</div>
                <div>{(order.total ?? 0).toLocaleString()} $</div>
              </div>

              {/* MOBILE VIEW */}
              <div className="md:hidden border-t px-4 py-3 text-gray-700 space-y-1">
                <div className="flex justify-between">
                  <span className="font-semibold text-gray-500">Sản phẩm:</span>
                  <span>{order.package.name}</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-semibold text-gray-500">Giá:</span>
                  <span>{(order.total ?? 0).toLocaleString()} $</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-semibold text-gray-500">Số lượng:</span>
                  <span>1</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-semibold text-gray-500">Tổng tiền:</span>
                  <span className="font-semibold">{(order.total ?? 0).toLocaleString()} $</span>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* SELLER */}
        <p className="mt-6 text-gray-700">
          <span className="font-semibold">Người bán hàng:</span>{" "}
          <span className="font-semibold text-gray-800">Hệ thống</span>
        </p>

        {/* TOTAL */}
        <div className="mt-4 pt-4 border-t flex flex-col items-end text-gray-700 space-y-1">
          <p>
            <span className="font-semibold">Tạm tính:</span>{" "}
            {(order.subtotal ?? order.total ?? 0)?.toLocaleString()} $
          </p>
          <p>
            <span className="font-semibold">Thành tiền:</span>{" "}
            {(order.total ?? 0)?.toLocaleString()} $
          </p>
          <p className="text-green-600 font-semibold">
            Tổng: {(order.total ?? 0)?.toLocaleString()} $
          </p>
        </div>
      </div>
    </Layout>
  );
}
